import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const matiTrades: SeasonTrades[] = [
  {
    season: "2009/10",
    allTrades: [
      {
        otherTeam: manager.itay,
        sentAway: "David West, Allen Iverson",
        gotInReturn: "Andrea Bargnani",
      },
    ],
  },
  {
    season: "2010/2011",
    allTrades: [
      {
        otherTeam: manager.kobe,
        sentAway: "Luke Ridnour, Marcus Camby",
        gotInReturn: "Emeka Okafor",
      },
    ],
  },
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.nissim,
        sentAway: "Carmelo Anthony and Raymond Felton",
        gotInReturn: "Danny Granger and Marcin Gortat",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Marcus Camby",
        gotInReturn: "Raymond Felton",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Luol Deng and Kevin Seraphin",
        gotInReturn: "Paul Pierce",
      },
    ],
  },

  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Michael Beasley",
        gotInReturn: "Jameer Nelson",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Marcin Gortat and Mike Dunleavy Jr",
        gotInReturn: "Tyreke Evans and Ryan Anderson",
      },
      {
        otherTeam: manager.jDog,
        sentAway: "Arron Afflalo",
        gotInReturn: "George Hill",
      },
    ],
  },

  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.chauncey,
        sentAway: "Blake Griffin",
        gotInReturn: "Marc Gasol and Chandler Parsons",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Jeff Green",
        gotInReturn: "Robin Lopez",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Chandler Parsons",
        gotInReturn: "Nikola Pekovic",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Marc Gasol and Kyle Lowry",
        gotInReturn: "Ty Lawson and David Lee",
      },
    ],
  },

  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "Mike Conley and 3rd pick in Veterans Draft",
        gotInReturn:
          "Paul George (Out For Season) and 11th pick in Veterans Draft",
      },
      {
        otherTeam: manager.idan,
        sentAway: "DeAndre Jordan, Tobias Harris and Darren Collison",
        gotInReturn: "Jabari Parker, Kenneth Faried and Arron Afflalo",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Enes Kanter",
        gotInReturn: "Marcus Smart",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Kenneth Faried and Robert Covington",
        gotInReturn: "Monta Ellis and Tristan Thompson",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Monta Ellis",
        gotInReturn: "Isaiah Canaan",
      },
    ],
  },

  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.chauncey,
        sentAway: "Kenneth Faried",
        gotInReturn: "Dirk Nowitzki",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Dirk Nowitzki",
        gotInReturn: "Thaddeus Young",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Omri Casspi",
        gotInReturn: "Tobias Harris",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Derrick Favors",
        gotInReturn: "Kevin Love",
      },
    ],
  },
  {
    season: "2016/17",
    allTrades: [
      {
        otherTeam: manager.kobe,
        sentAway: "Jabari Parker and 5th round pick",
        gotInReturn: "3rd round pick",
        amongBestTrades: true
      },
      {
        otherTeam: manager.itay,
        sentAway: "D'Angelo Russell",
        gotInReturn: "Jeremy Lin",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Steven Adams and Evan Fournier",
        gotInReturn: "Julius Randle",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "JJ Redick and 1st round pick",
        gotInReturn: "Jeff Teague and 4th round pick",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Goran Dragic and Will Barton",
        gotInReturn: "Bradley Beal",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Kevin Durant",
        gotInReturn: "Stephen Curry",
        amongBestTrades: true
      },
      {
        otherTeam: manager.itay,
        sentAway: "Robert Covington and Jeff Teague",
        gotInReturn: "Jusuf Nurkic and Jeremy Lin",
      },
    ],
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.shiran,
        sentAway: "Paul George and DeAron Fox",
        gotInReturn: "Rondae Hollis-Jefferson and Jrue Holiday",
        amongWorstTrades: true,
      },
      {
        otherTeam: manager.shiran,
        sentAway: "Julius Randle",
        gotInReturn: "TJ Warren",
      },
      {
        otherTeam: manager.itay,
        sentAway: "JJ Redick and Michael Beasley",
        gotInReturn: "Nikola Mirotic",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Brook Lopez",
        gotInReturn: "Gary Harris",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Jrue Holiday and Gary Harris",
        gotInReturn: "Jeff Teague",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Stephen Curry and Steven Adams",
        gotInReturn: "Giannis Antetokounmpo and JJ Redick",
        amongBestTrades: true,
      },
    ],
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.zeev,
        sentAway: "Mario Hezonja",
        gotInReturn: "Will Barton"
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Malcolm Brogdon",
        gotInReturn: "Caris LeVert",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Clint Capela",
        gotInReturn: "Jarret Allen and Rudy Gay",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Giannis Antetokounmpo and Chris Paul",
        gotInReturn: "Joel Embiid and Kyle Lowry",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.itay,
        sentAway: "Joel Embiid, Myles Turner, Jarrett Allen and Kyle Lowry",
        gotInReturn: "Anthony Davis, Julius Randle and Andrew Wiggins",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Julius Randle",
        gotInReturn: "Kevin Knox",
      },
    ],
  },
  {
    season: "2019/20",
    allTrades: [
      {
        otherTeam: manager.ilya,
        sentAway: "Caris LeVert",
        gotInReturn: "PJ Tucker",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Lou Williams",
        gotInReturn: "Kendrick Nunn",
      },
      {
        otherTeam: manager.dror,
        sentAway: "Steven Adams and Will Barton",
        gotInReturn: "Kevin Love",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Kevin Love and Ricky Rubio",
        gotInReturn: "Chris Paul",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Marquese Chriss",
        gotInReturn: "Jaylen Brown",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Victor Oladipo and Jaylen Brown",
        gotInReturn: "TJ Warren",
      },
    ],
  },
  {
    season: "2020/21",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "3rd round pick",
        gotInReturn: "Devonte Graham and 4th round pick",
      },
      {
        otherTeam: manager.dror,
        sentAway: "Kemba Walker and Evan Fournier",
        gotInReturn: "Duncan Robinson and Seth Curry",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Bam Adebayo",
        gotInReturn: "Tyrese Haliburton",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.ilya,
        sentAway: "DeMar DeRozan",
        gotInReturn: "Gordon Hayward",
      },
    ],
  },
  {
    season: "2021/22",
    allTrades: [
      {
        otherTeam: manager.rony,
        sentAway: "Will Barton",
        gotInReturn: "Mike Conley",
      },
      {
        otherTeam: manager.dror,
        sentAway: "LeBron James and Nicolas Batum",
        gotInReturn: "Norman Powell",
        amongWorstTrades: true,
      },
      {
        otherTeam: manager.itay,
        sentAway: "Montrezl Harrell",
        gotInReturn: "Harrison Barnes",
      },
      {
        otherTeam: manager.rony,
        sentAway: "OG Anunoby",
        gotInReturn: "Christian Wood",
      },
      {
        otherTeam: manager.dror,
        sentAway: "Harrison Barnes and Mike Conley",
        gotInReturn: "Russell Westbrook",
      },
      {
        otherTeam: manager.shiran,
        sentAway:
          "Anthony Davis, Russell Westbrook, Christian Wood and Kyle Kuzma",
        gotInReturn: "Dejounte Murray, Khris Middleton and Daniel Gafford",
        amongWorstTrades: true,
      },
      {
        otherTeam: manager.rony,
        sentAway: "Jarrett Allen (Out For Season)",
        gotInReturn: "Jonas Valanciunas",
        amongBestTrades: true,
      },
    ],
  },
  {
    season: "2022/23",
    allTrades: [
      {
        otherTeam: manager.rony,
        sentAway: "Devin Vassell and 5th round pick",
        gotInReturn: "3rd round pick (#25)",
        amongBestTrades: true
      },
      {
        otherTeam: manager.idan,
        sentAway: "Keegan Murray, Jamal Murray, Michael Porter Jr and 1st round pick",
        gotInReturn: "LeBron James, Rudy Gobert, Isaiah Jackson and 3rd round pick"
      },
      {
        otherTeam: manager.idan,
        sentAway: "Fred VanVleet",
        gotInReturn: "Anfernee Simons",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.yoni,
        sentAway: "Aaron Gordon",
        gotInReturn: "Tobias Harris"
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Rudy Gobert and Qunetin Grimes",
        gotInReturn: "Mitchell Robinson and Buddy Hield",
        amongBestTrades: true
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Tobias Harris and Anfernee Simons",
        gotInReturn: "Jrue Holiday"
      },
      {
        otherTeam: manager.dom,
        sentAway: "Dejounte Murray",
        gotInReturn: "John Collins",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.itay,
        sentAway: "Chris Paul",
        gotInReturn: "Kevin Huerter"
      },
      {
        otherTeam: manager.itay,
        sentAway: "LeBron James",
        gotInReturn: "Klay Thompson"
      }
    ],
  },
  {
    season: "2023/24",
    allTrades: [
      {
        otherTeam: manager.yoni,
        sentAway: "Franz Wagner", 
        gotInReturn: "Mikal Bridges",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Trey Murphy",
        gotInReturn: "Lauri Markkanen",
        amongBestTrades: true
      },
      {
        otherTeam: manager.dom,
        sentAway: "Lauri Markkanen",
        gotInReturn: "Myles Turner",
        amongBestTrades: true
      },
      {
        otherTeam: manager.idan,
        sentAway: "Domantas Sabonis and Tari Eason",
        gotInReturn: "Jalen Williams and Jakob Poeltl"
      },
      {
        otherTeam: manager.rony,
        sentAway: "Rudy Gobert, Khris Middleton and 1st round pick (#6)",
        gotInReturn: "Jarrett Allen and 1st round pick (#2)",
        amongBestTrades: true
      },
      {
        otherTeam: manager.yoni,
        sentAway: "Jamal Murray",
        gotInReturn: "Fred VanVleet"
      }
    ]
  },
  {
    season: "2024/25",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Myles Turner", 
        gotInReturn: "Jordan Poole"
      },
      {
        otherTeam: manager.shahar,
        sentAway: "Jalen Johnson (OFS)",
        gotInReturn: "Ivica Zubac",
        amongBestTrades: true
      },
      {
        otherTeam: manager.idan,
        sentAway: "Kawhi Leonard and Matas Buzelis",
        gotInReturn: "Dyson Daniels",
        amongBestTrades: true
      },
    ]
  }
];
